module.exports = __webpack_public_path__ + "media/images/lb/197-f4c377401466489d8570f0edfd970670.svg";